/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Componente_LC_76_67 as Componente_LC_76_67,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ResolverObservacion as ResolverObservacion,
  rec_api as api,
} from "../../runtime/index.jsx";
export function SeguimientoObservaciones({ actaId: e }) {
  let [t, n] = (0, React.useState)(null),
    [r, i] = (0, React.useState)(null),
    [a, o] = (0, React.useState)(0),
    [s, c] = (0, React.useState)(null),
    [l, u] = (0, React.useState)(``),
    f = (0, React.useCallback)(async () => {
      try {
        u(``);
        let [t, r] = await Promise.all([
          api(
            `/inspecciones/observaciones?${e ? `actaId=${e}` : `pagina=${a}`}`,
            {
              sinCache: !0,
            },
          ),
          e
            ? Promise.resolve(null)
            : api(`/inspecciones/observaciones/resumen`, {
                sinCache: !0,
              }),
        ]);
        (n(t), i(r));
      } catch (e) {
        u(e.message);
      }
    }, [e, a]);
  (0, React.useEffect)(() => {
    f();
  }, [f]);
  let p = r && r.total > 0 && r.pendientes === 0;
  return (
    <section
      className={`space-y-3`}
      children={[
        <h2
          className={`text-sm font-medium text-(--text-h) !m-0`}
          children={e ? `Seguimiento de observaciones` : `Por levantar`}
        />,
        <EstadoError mensaje={l} onReintentar={f} />,
        r && (
          <div
            className={`grid grid-cols-2 gap-3 text-sm`}
            children={[
              <div
                className={`rounded-xl border border-(--border) p-3`}
                children={[
                  <p
                    className={`text-xs text-(--text)`}
                    children={`Pendientes`}
                  />,
                  <p
                    className={`text-xl font-semibold text-(--text-h)`}
                    children={r.pendientes}
                  />,
                ]}
              />,
              <div
                className={`rounded-xl border border-(--border) p-3`}
                children={[
                  <p
                    className={`text-xs text-(--text)`}
                    children={`Vencidas`}
                  />,
                  <p
                    className={`text-xl font-semibold text-(--text-h)`}
                    children={r.vencidas}
                  />,
                ]}
              />,
            ]}
          />
        ),
        p && (
          <p
            className={`text-sm text-(--success)`}
            children={`100% de las observaciones levantadas.`}
          />
        ),
        t ? (
          t.length ? (
            <ul
              className={`max-h-[34rem] divide-y divide-(--border) overflow-y-auto rounded-2xl border border-(--border)`}
              children={t.map((e) => (
                <li
                  key={e.id}
                  className={`space-y-2 p-3 text-sm`}
                  children={[
                    <div
                      className={`flex flex-wrap justify-between gap-2`}
                      children={[
                        <p
                          className={`font-medium text-(--text-h)`}
                          children={[e.etiqueta, ` · Acta #`, e.inspeccionId]}
                        />,
                        <span
                          className={
                            e.estado === `RESUELTA`
                              ? `text-(--success)`
                              : `text-(--warning)`
                          }
                          children={
                            e.estado === `RESUELTA` ? `Levantada` : `Pendiente`
                          }
                        />,
                      ]}
                    />,
                    <p className={`break-words`} children={e.observacion} />,
                    <p className={`break-words`} children={e.accion} />,
                    <p
                      className={`text-xs text-(--text)`}
                      children={[e.responsable, ` · Hasta `, e.fechaCompromiso]}
                    />,
                    e.estado === `RESUELTA` ? (
                      <p className={`break-words`} children={e.solucion} />
                    ) : s === e.id ? (
                      <ResolverObservacion
                        observacion={e}
                        onCancelar={() => c(null)}
                        onListo={async () => {
                          (c(null), await f());
                        }}
                      />
                    ) : (
                      <AccionAsync
                        variante={`secundario`}
                        className={`min-h-11`}
                        onClick={() => c(e.id)}
                        children={`Levantar observación`}
                      />
                    ),
                  ]}
                />
              ))}
            />
          ) : (
            <p
              className={`text-sm text-(--text)`}
              children={`No hay observaciones pendientes en esta página.`}
            />
          )
        ) : (
          !l && <Componente_LC_76_67 cantidad={2} />
        ),
        !e && (
          <div
            className={`flex justify-between gap-2`}
            children={[
              <AccionAsync
                variante={`texto`}
                className={`min-h-11`}
                disabled={a === 0}
                onClick={() => o(a - 1)}
                children={`Anteriores`}
              />,
              <AccionAsync
                variante={`texto`}
                className={`min-h-11`}
                disabled={!t || t.length < 20}
                onClick={() => o(a + 1)}
                children={`Más observaciones`}
              />,
            ]}
          />
        ),
      ]}
    />
  );
}
